module.exports = __webpack_public_path__ + "img/b_AnevilSirop_up.6dc5e292.jpeg";